import {Injectable} from "@angular/core";
import moment from "moment";
import {Pure} from "../../decorators";

export function transformToISODate(date: string): any {
  return moment(date).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

@Injectable()
export class IntGetDateInfoDependFormatService {
  @Pure
  getDateInfoDependFormat(valueAt: [string , string] | [string], valueAtFrom: string, valueAtTo: string, timeRangePrefix: string): string | string[] | null {
    if (valueAt && Array.isArray(valueAt)) {
      if (valueAt.length === 1) {
        return [
          transformToISODate(valueAt[0])
        ];
      } else if (valueAt.length === 2) {
        return [
          transformToISODate(valueAt[0]),
          transformToISODate(valueAt[1])
        ];
      }
    }
    if (valueAt) {
      return transformToISODate(valueAt);
    } else if (valueAtFrom && valueAtTo) {
      return [
        transformToISODate(valueAtFrom),
        transformToISODate(valueAtTo)
      ]
    } else {
      return null
    }
  }
  static createDateAtListByURLParams(at= '', atTo = '', atFrom = ''): string[] | null {
    if(at) {
      return [transformToISODate(at)]
    }else if(atTo && atFrom){
      return [transformToISODate(atFrom), transformToISODate(atTo)]
    }else if (atTo) {
      return [transformToISODate(atTo)]
    }else if (atFrom) {
      return [transformToISODate(atFrom)]
    }else {
      return null;
    }
  }
}



@Injectable()
export class IntFilterPayloadFormatterService {

  constructor(private readonly patchFormFormatter: IntGetDateInfoDependFormatService) {
  }

  private formatDate(value: string): string {
    return moment(value).format('YYYY-MM-DD');
  }

  private computeTimeFieldsForValidFormat<T>(data: T, datesPrefix: string[]): any {
    return datesPrefix.map((datePrefix) => {
      // @ts-ignore
      const timeData = data[datePrefix + 'At'];

      if(Array.isArray(timeData) && timeData.length === 1) {
        return {
          [datePrefix + 'AtFrom']: this.formatDate(timeData[0])
        }
      } else if(
        Array.isArray(timeData)
        &&
        timeData.length === 2 && timeData[0].toString() !== timeData[1].toString()
      ) {
        return {
          [datePrefix + 'AtFrom']: this.formatDate(timeData[0]),
          [datePrefix + 'AtTo']: this.formatDate(timeData[1])
        }
      } else if(
        Array.isArray(timeData)
        &&
        timeData.length === 2
        && timeData[0].toString() === timeData[1].toString()
      ) {
        return {
          [datePrefix + 'At']: this.formatDate(timeData[0])
        }
      }else {
        return {[datePrefix + 'At']: timeData}
      }
    }).reduce((acc, pair) => {
      return {...acc, ...pair};
    }, {})
  }

  isPrefixValue(key: any,  prefixes: string[]) {
    return prefixes.some((prefix) => {
      return [prefix + 'At', prefix + 'AtFrom', prefix + 'AtTo'].indexOf(key) !== -1
    });
  }

  private transformParamsData<T>(data: T, datePrefixes: string[]): T {
    let output: any = {};
    for(let key in data) {
      if(this.isPrefixValue(key, datePrefixes)) {
        continue;
      }else{
        output[key] = data[key];
      }
    }
    Object.assign(output, this.computeTimeFieldsForValidFormat<T>(data, datePrefixes));
    return output;
  }

  private parameterValueNotFalsy(value: unknown): boolean {
    return !!value && value !== 'false'
  }

  private removeFieldsByEmptyValue(data: any) {
    return Object.entries(data).filter(([key, value]) => {
      return this.parameterValueNotFalsy(value)
    }).reduce((acc, item) => {
      acc[item[0]] = item[1];
      return acc;
    }, {} as any)
  }

  clearParams(data: any, datePrefix: string[] = ['']) {
    return Object
      .entries(this.transformParamsData(data, datePrefix))
      .filter(([_, value]) => Boolean(value))
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {} as any)
  }

  transformParamsToPatchData<A>(data: A, dateFieldsPrefixList: string[]) {
    let o = {};
    for(let key in data) {
      if(this.isPrefixValue(key, dateFieldsPrefixList)) {
        continue;
      }else{
        // @ts-ignore
        o[key] = data[key];
      }
    }
    return dateFieldsPrefixList.reduce((acc, prefix) => {
      let f = this.patchFormFormatter.getDateInfoDependFormat(
        // @ts-ignore
        data[prefix + 'At'],
        // @ts-ignore
        data[prefix + 'AtFrom'],
        // @ts-ignore
        data[prefix + 'AtTo'],
        prefix
      );
      // @ts-ignore
      acc[prefix + 'At'] = f;
      return acc;
    }, this.removeFieldsByEmptyValue(o));
  }
}
